import user from "./zh-CN/user";

export default {
  ...user,
};
